module.exports = __webpack_public_path__ + "img/ring_g_o_1_null.f3cc69b2.png";